import { EventScorekeepingFeedItemFragment } from '@/components/Event/EventScorekeeping/EventScorekeepingFeed/EventScorekeepingFeedItem';
import { type graphql, readFragment } from '@/gql/graphql';
import type { EventScorekeepingPanelFormValues } from '../EventScorekeeping.types';

export function buildScorekeepingAssignmentMutationVariables({
  eventId,
  values,
}: {
  eventId: string;
  values: EventScorekeepingPanelFormValues;
}) {
  const recipients = values.recipients.filter(
    (recipient) => !recipient.isDeleted,
  );
  const deletedAssigneeIds = values.recipients
    .filter((recipient) => recipient.isDeleted)
    .map((recipient) => recipient.id);
  const primaryAssignee = readFragment(
    EventScorekeepingFeedItemFragment,
    recipients[0],
  );

  if (!primaryAssignee.person_team?.person?.id) {
    return null;
  }

  const badgeAssignees = recipients.map((recipient, index) => {
    const obj: ReturnType<
      typeof graphql.scalar<'badge_assignee_insert_input'>
    > = {
      id: recipient.id,
      badge_id: recipient.badge.id,
      person_id: recipient.person_team?.person?.id,
      parent_id: primaryAssignee.id,
      team_id: recipient.person_team?.team?.id,
      event_id: eventId,
      order: index !== 0 ? index : null,
      elapsed_segment_ms: values.selectedTime?.elapsed_segment_ms,
      event_segment_id: values.selectedTime?.event_segment?.id,
      badge_assignee_attributes: {
        data: recipient.badge_assignee_attributes.map((recipientAttribute) => {
          const valueColumn =
            recipientAttribute.badge_attribute.attribute_type === 'text'
              ? 'text_value'
              : 'numeric_value';

          return {
            id: recipientAttribute.id,
            badge_attribute_id: recipientAttribute.badge_attribute.id,
            [valueColumn]: recipientAttribute.value || null,
          };
        }),
        on_conflict: {
          constraint: 'badge_assignee_attribute_pkey',
          update_columns: ['text_value', 'numeric_value'],
        },
      },
    };

    return obj;
  });

  return {
    badgeAssignees,
    deletedAssigneeIds,
  };
}
